import { Injectable } from '@angular/core';
import { Observable, Subject} from 'rxjs';
import {filter} from 'rxjs/operators';

export interface Event {
  id: number;
  name: string;
  date: Date;
  location: string;
  description: string;
  action: string;
}

@Injectable({
  providedIn: 'root'
})

export class EventService {

  // private event: Event;
  private subject = new Subject<Event>();
  // private subjectPostChange = new Subject<any>();
  // private eventsSubject = new BehaviorSubject<Event[]>(this.events);

  constructor() { }

  /**
   * Emits the provided event to observers.
   *
   * @param {Event} event - The event to emit to observers.
   *
   * @return {void}
   */
  emit(event: Event): void {
    this.subject.next(event);
  }

  broadcast(name: string, data: any): void {
    this.subject.next({
      id: 0,
      name: name,
      date: new Date(),
      location: '',
      description: '',
      action: data
    });
  }

  /**
   * Filters the events emitted by the generic subject by name.
   *
   * @param {string} eventName - The name of the event to filter by.
   * @return {Observable<any>} An Observable that emits only the events with the specified name.
   */
  eventFilteredByName(eventName: string): Observable<any> {
    return this.subject.pipe(filter((eventFilter: any) => eventFilter.name === eventName));
  }
}
